// initialize tracking with the pageview event
function initTracking() {
  const hostName = window.location.hostname;
  const env =
    hostName.includes("preview") || hostName.includes("localhost")
      ? "preview"
      : "production";
  window.ttt.init(env, { clearParams: false });

  window.ttt.pageview(
    "wbm/Stellenmarkt",
    "wbm/Stellenmarkt/job_agent/index",
    {}
  );
  console.log("pageview wbm/Stellenmarkt/job_agent/index");
}

// private helper function to extract the value of a given GET parameter from the current URL
function getParamValue(paramName) {
  let queryString = window.location.search.substring(1);
  let params = queryString.split("&");

  for (let i = 0; i < params.length; i++) {
    let parts = params[i].split("=");

    if (parts[0] === paramName) {
      return decodeURIComponent(parts[1]);
    }
  }
}

// add tracking campaign parameters to a given URL (e.g. sc_cmp)
function addTrackingParamToURL(url) {
  let paramValue = getParamValue("brt") || getParamValue("sc_cmp");
  let isValidCode =
    paramValue && paramValue.length > 9 && paramValue.length < 255;

  if (isValidCode) {
    let paramName = getParamValue("brt") ? "sc_pce" : "sc_cmp";

    let divider = "?";

    if (url.indexOf("?") != -1) {
      // contains questionmark
      divider = "&";
    }

    url = url + divider + paramName + "=" + paramValue;
  }

  return url;
}

// track whether user has scrolled into viewport of an element
function hasScrolledIntoViewOfSection(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // partially visible elements return true:
  var isVisible = elemTop < window.innerHeight && elemBottom >= 0;

  return isVisible;
}

// ttt event proptrackaction
function firePropTrackAction(trackingValue) {
  const trackingParams = { PropTrackAction: trackingValue };
  window.ttt.event("PropTrackAction", trackingParams);
  console.log("event PropTrackAction", trackingParams);
}

// ttt event propscrolling
function firePropScrolling(trackingValue) {
  const trackingParams = {
    PropScrolling: "",
    PropModules: trackingValue,
  };
  window.ttt.event("PropScrolling", trackingParams);
  console.log("event PropScrolling", trackingParams);
}

module.exports = {
  initTracking,
  addTrackingParamToURL,
  hasScrolledIntoViewOfSection,
  firePropTrackAction,
  firePropScrolling,
};
